import '../../App.less';
import {Comment,Avatar,Layout, Select,Tooltip, Row, Col,ConfigProvider,Table,Modal,Menu,Input, Space ,notification,AutoComplete, Card, Checkbox, Radio, Spin } from 'antd';
import React, { Component, Fragment } from "react";
import cabezal from '../Cabezal.jpg'
import 'react-phone-input-2/lib/style.css'
import es_ES from 'antd/lib/locale/es_ES';
import {NavLink} from "react-router-dom";
import { Button } from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined,CalendarOutlined,CloseOutlined,CheckOutlined,EditOutlined, UserOutlined,TagsOutlined,HomeOutlined,FileTextOutlined,FilePdfOutlined, AuditOutlined,QrcodeOutlined,LogoutOutlined,MessageOutlined } from '@ant-design/icons';
import moment from 'moment'
import axios from "axios";
import {getAuthors,getAuthorsStr,IP,countDownNotification, downloadFile, readFile, getComments} from '../components/utils';
import Foot from "../components/Footer"
import JuryMenu from "../components/JuryMenu"


class FinalPlayslist extends Component {
  constructor(props){
    super(props)
    this.state={
      plays:[],
      showArticle:false,
      record:null,
      edit:false,
      categoryChanged:"",
      current_jury:undefined,
      showCommentSection:false,
      comment:{},
      jurys_dict:{},
      edit_comment:undefined,
      selected_comment:undefined,
      comment_new_text:undefined,
      loaded_table_data:false,
      qualifications_dict:{},
      qualifications_changed:{},
      isBusy:true,
      selectedPlay:undefined,
      openEditFinalComment:false,
      current_jury_qualifications:{},
      finalCommentText:undefined
    }
  }

  async componentWillMount() {
    //Jury
    const response_jury= await fetch(IP + 'api/casa/jurado/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const json_jury = await response_jury.json();
    if(json_jury['detail']){
      localStorage.clear()
      window.location.reload(); 
    }
    const jury_user = localStorage.getItem("User")
    const current_jury = json_jury.filter(j=>j.usuario.toLowerCase() == jury_user.toLowerCase())[0]
    
    //Genre
    const genre = await fetch(IP + 'api/casa/genero/');
    this.json_g = await genre.json();
    this.genres_dict = {};
    this.json_g.forEach(element => {
      this.genres_dict[element.id] = element.nombre
    });
    
    //Plays
    const response_plays = await fetch(IP + 'api/casa/obra/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const json_plays = await response_plays.json();
    const jurys_dict={}
    Object.entries(json_jury).forEach(element => {
      if(this.genres_dict[element[1].genero] != 'Admin' && (this.genres_dict[current_jury.genero] == 'Admin' || element[1].genero == current_jury.genero)  )
        jurys_dict[element[1].id]=element[1]
    });


    //Qualifications
    var qual_url = new URL(IP + 'api/casa/calificacion/')
    const qualifications = await fetch(qual_url,{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
    });
    const json_qualifications = await qualifications.json()
    const prequalifications_dict={}
    const all_qualifications_comments = {}
    const qualifications_dict={}
    var current_jury_qualifications = {}
    var selectedPlay = undefined
    json_qualifications.forEach(element => {
      if(element.jurado == current_jury.id){
        current_jury_qualifications[element.obra] = element
        if(element.puntaje == 3)
          selectedPlay = element.obra
      }
      if(element.jurado.toString() in jurys_dict && (element.puntaje == 2 || element.puntaje == 3)){
       element.obra.toString() in prequalifications_dict ? prequalifications_dict[element.obra] +=1 : prequalifications_dict[element.obra] =1
        if(element.obra.toString() in qualifications_dict){
          all_qualifications_comments[element.obra][element.jurado] = element.comentario
          qualifications_dict[element.obra][element.jurado] = (element.puntaje == 3)
          qualifications_dict[element.obra]['id']=element.id
        }
        else{
          qualifications_dict[element.obra]={}
          all_qualifications_comments[element.obra] = {}
          for(var j in jurys_dict){
            qualifications_dict[element.obra][j]=null
            all_qualifications_comments[element.obra][j] = ''
          }
          qualifications_dict[element.obra][element.jurado]=(element.puntaje == 3)
          qualifications_dict[element.obra]['id']=element.id
          all_qualifications_comments[element.obra][j] = element.comentario
        }
      }
      
    });
    var jurysCount = Object.entries(jurys_dict).length
    const requiredPreselected = (jurysCount % 2) == 1 ? (Math.floor(jurysCount / 2) + 1) : (jurysCount / 2)

    for(var i in prequalifications_dict){
      if(prequalifications_dict[i] < requiredPreselected)
        delete qualifications_dict[i]
    }
    var data = []
    this.authorsStr = new Set();
    this.categories = new Set();
    this.codes = new Set();
    this.titles = new Set();
    this.dates = new Set();
    this.pseudos = new Set();
    this.edits = [];
    const Moment = require('moment');
    
    for(var i in json_plays){
      const item = json_plays[i];
      
      if(!(item.id.toString() in qualifications_dict) || prequalifications_dict[item.id] < requiredPreselected)
        continue

      if(item.genero != current_jury.genero  && this.genres_dict[current_jury.genero] != 'Admin'){
        continue
      }
      var date= new Moment(item.fecha_registro).format('DD-MM-YYYY')
      var author= getAuthors(item.conc)
      var a= getAuthorsStr(item.conc)
      for(var j in a ){
        this.authorsStr.add(a[j])
      }
      
      var authorStr = getAuthorsStr(item.conc).join(", ")
      this.categories.add(this.genres_dict[item.genero])
      this.titles.add(item.titulo);
      this.dates.add(date);
      this.edits.push("")
      this.pseudos.add(item.pseudonimo)
      const year = date.split('-')[2]
      this.codes.add(year+'_'+item.genero+'_'+item.id);
      var play = { 
        id : item.id,
        title : item.titulo,
        author: author ,
        authorStr:authorStr,
        date:date,
        pseudo: item.pseudonimo,
        code:year+'_'+item.genero+'_'+item.id,
        conc:item.conc,
        category:this.genres_dict[item.genero],
        categoryObj:{id:item.genero, nombre:this.genres_dict[item.genero] },
        pdf:item.pdf,
        edit:''
      }
      for(var j in jurys_dict){
        play[j] = j==current_jury.id ? 
           <div><Radio onChange={(e)=>{selectedPlay == item.id ? console.log("Es la misma"):this.changeQualification(item.id.toString() in current_jury_qualifications ? current_jury_qualifications[item.id].id:null,3,item.id,selectedPlay !=undefined? current_jury_qualifications[selectedPlay]: selectedPlay)}} checked={item.id ==selectedPlay}/>{item.id ==selectedPlay && <Tooltip  overlayStyle={{ whiteSpace: 'pre-line' }} title={current_jury_qualifications[item.id].comentario}><MessageOutlined style={{color:'orange'}} onClick={()=>this.setState({openEditFinalComment:true, finalCommentText:current_jury_qualifications[item.id].comentario})}/></Tooltip>}</div>
            : qualifications_dict[item.id][j] ? <div> <CheckOutlined style={{color:"green"}} /><Tooltip title={all_qualifications_comments[item.id][j]}overlayStyle={{ whiteSpace: 'pre-line' }} > <MessageOutlined style={{color:'orange'}}/></Tooltip></div>:' '
      }
      data.push(play)
    };

    this.categories =[...this.categories].map((v)=>{
      return {value:v}
    })
    this.codes = [...this.codes].map((v)=>{
      return {value:v}
    })
    this.titles = [...this.titles].map((v)=>{
      return {value:v}
    })
    this.dates = [...this.dates].map((v)=>{
      return {value:v}
    })

    this.pseudos = [...this.pseudos].map((v)=>{
      return {value:v}
    })
    
    this.authorsStr = [...this.authorsStr].map((v)=>{
      return {value:v}
    })
    this.setState({current_jury_qualifications:current_jury_qualifications,current_jury:current_jury, jurys_dict:jurys_dict, plays: data ,loaded_table_data:true,filteredInfo:data,qualifications_dict:qualifications_dict,selectedPlay:selectedPlay});
  }

  onClickArticle = record  => {
        this.setState({showArticle:true,record:record});
  };
 
  hideModal = () => {
    this.setState({showArticle: false,record: null});
  };

  hideEdit = () => {
    this.setState({
      edit: false,
      record: null,
    });
};
async saveQualification(record_id){
  if (record_id in this.state.qualifications_changed){
    if(!(record_id in this.state.qualifications_dict)){//if it didn't exist, we have to post
      const data= new FormData()
      data.append('jurado',this.state.current_jury.id)
      data.append('obra',record_id)
      data.append('puntaje',this.state.qualifications_changed[record_id])
      axios.post(IP + 'api/casa/calificacion/', data).then((res) => {
     
      }).catch((err) => {
        notification.error({
          message:'Error',
          description:"Hubo un error. Intente mas tarde por favor",
        });
    })}
    else{//if it did exist, we have to patch
      var options = {
        method: "patch",
        credentials: "same-origin",
        headers: {
          "Authorization": localStorage.getItem("Authorization") ,
          "Accept": "application/json",
          "Content-Type": "application/json"},
       
      }
      var editedQualification = {
        puntaje: this.state.qualifications_changed[record_id],
        comentario:''
      }
      await axios.patch(IP + `api/casa/calificacion/${this.state.qualifications_dict[record_id].id}/`, editedQualification, options)
      .then(
        (response) => {
         if(response.status === 200)
           window.location.reload();
        },
        (error) => {
          console.log(error);
        }
      ).catch((err) => console.log(err))
    }
  }

}
onChangeSelect(value){
  this.setState({categoryChanged:value})
}

handleTableChange = (pagination, filters, sorter, extra) => {
  this.setState({
    filteredInfo: extra['currentDataSource']
  });
}
getAutocomplete = (dataIndex) =>{
  if(dataIndex == "code"){
    return this.codes
  }
  else if (dataIndex == "title" ) {
    return this.titles
  } 

  else if (dataIndex== "author"){
    return  this.authorsStr
  }

  else if (dataIndex== "category"){
    return this.categories
  }
  else if (dataIndex== "pseudo"){
    return this.pseudos
  }
  else{
    return this.dates
  }
}
  async changeQualification(id,value,play_id,old_qualification=undefined){
    var success = true
      if(old_qualification != undefined){
        var options = {
          method: "patch",
          credentials: "same-origin",
          headers: {
            "Authorization": localStorage.getItem("Authorization") ,
            "Accept": "application/json",
            "Content-Type": "application/json"},
        }
        var editedQualification = {
          puntaje: 2,
          comentario:''
        }
        await axios.patch(IP + `api/casa/calificacion/${old_qualification.id}/`, editedQualification, options)
        .then(
          (response) => {
          if(response.status === 200){
            console.log("PATCH RECOVER SUCCESS")
          }
          },
          (error) => {
            success = false
            countDownNotification(notification.error, "Error", "Hubo un error al guardar los cambios.Intente más tarde por favor","failure")
          }
        ).catch((err) => {success=false; countDownNotification(notification.error, "Error", "Hubo un error al guardar los cambios.Intente más tarde por favor","failure")})
      }
      if(success){
        if(id == null){
          const data= new FormData()
          data.append('jurado',this.state.current_jury.id)
          data.append('obra',play_id)
          data.append('puntaje',value)
          await axios.post(IP + 'api/casa/calificacion/', data).then((res) => {
            this.setState({loaded_table_data:false},()=>this.componentWillMount())
          }).catch((err) => {
            notification.error({
              message:'Error',
              description:"Hubo un error. Intente mas tarde por favor",
              });
            })
      } 
      else{
        var options = {
          method: "patch",
          credentials: "same-origin",
          headers: {
            "Authorization": localStorage.getItem("Authorization") ,
            "Accept": "application/json",
            "Content-Type": "application/json"},
        }
        var editedQualification = {
          puntaje: value,
          comentario:''
        }
        await axios.patch(IP + `api/casa/calificacion/${id}/`, editedQualification, options)
        .then(
          (response) => {
            if(response.status === 200){
              this.setState({loaded_table_data:false},()=>this.componentWillMount())
            }
          },
          (error) => {
            countDownNotification(notification.error, "Error", "Hubo un error al guardar los cambios.Intente más tarde por favor","failure")
          }
        ).catch((err) => countDownNotification(notification.error, "Error", "Hubo un error al guardar los cambios.Intente más tarde por favor","failure"))
      }
    }
  }
  async onClickSave(){
    var options = {
      method: "patch",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
      proxy: {
        host: 'localhost:8000',
        port: 8000
      }
    }
    var playChanged={}
    playChanged={
        titulo: document.getElementById("inputTitle").value,
        genero: this.state.categoryChanged? this.state.categoryChanged:this.state.record.category=="Novela"? 1:this.state.record.category=="Poesía"?2:3,
        pseudonimo: document.getElementById("inputPseudo").value
      }

    this.state.record.author.map(async(i,index)=>{
      var editedAuthor={
        nombre_completo: document.getElementById("author"+i.id).value
      }
      await axios.patch(IP + `api/concursantes/${i.id}/`, editedAuthor, options)
      .then(
        (response) => {
        if(response.status === 200)
          console.log("OK")
        },
        (error) => {
          console.log(error);
        }
      ).catch((err) => console.log(err))
    })
    await axios.patch(IP + `api/casa/obra/${this.state.record.id}/`, playChanged, options)
    .then(
      (response) => {
        if(response.status === 200)
            window.location.reload()
        else{
            notification.error({
            message:'Error',
            description:'Hubo un error, por favor revise los datos',
          });
        }
      },
      (error) => {
        console.log(error);
      }
    ).catch((err) => console.log(err))
  }
  async postFinalComment(){
    const qualification= this.state.current_jury_qualifications[this.state.selectedPlay]
    var options = {
      method: "patch",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
    }
    var editedQualification = {
      comentario:this.state.comment_new_text
    }
    await axios.patch(IP + `api/casa/calificacion/${qualification.id}/`, editedQualification, options)
    .then(
      (response) => {
       if(response.status === 200){
        this.setState({loaded_table_data:false,savingComment:false},()=>this.componentWillMount())
       }
      },
      (error) => {
        this.setState({savingComment:false},()=>countDownNotification(notification.error, "Error", "Hubo un error al guardar los cambios.Intente más tarde por favor","failure"))
      }
    ).catch((err) =>  this.setState({savingComment:false},()=>countDownNotification(notification.error, "Error", "Hubo un error al guardar los cambios.Intente más tarde por favor","failure")))
  }

  async postComment(play_id,parentComment){
    const data= new FormData()
    data.append('jurado',this.state.current_jury.id)
    data.append('obra',play_id)
    data.append('texto',this.state.comment_new_text)
    if(parentComment){
      data.append('comentario_padre',parentComment)
    }
    axios.post(IP + 'api/casa/comentario/', data).then(async (res) => {
      if (res.status == 200){
        const comments_dict = await getComments(play_id)
        this.setState({comment:comments_dict,selected_comment:undefined,answer_comment:false, comment_new_text:''})
      } 
      }).catch((err) => {
        notification.error({
          message:'Error',
          description:"Hubo un error. Intente mas tarde por favor",
        });
    })
  }
  
  async saveEditComment(play_id,commentId){
    var options = {
      method: "patch",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
    }
    var editedComment = {
      texto: this.state.comment_new_text
    }
    await axios.patch(IP + `api/casa/comentario/${commentId.toString()}/`, editedComment, options)
    .then(
      async(response) => {
       if(response.status === 200)
       var comments_dict = await getComments(play_id)
       this.setState({comment:comments_dict,edit_comment:false,selected_comment:undefined, comment_new_text:undefined},()=>countDownNotification(notification.success,'Completado','El mensaje se guardó de forma exitosa','success'))
      },
      (error) => {
        console.log(error);
      }
    ).catch((err) => console.log(err))
  }
  
  async deleteComment(play_id,commentId){
    fetch(IP + `api/casa/comentario/${commentId.toString()}/`,{
      method:'DELETE',
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
     
    }).then(async (res) => {
      if (res.status == 204){
        var comments_dict = await getComments(play_id)
        this.setState({comment:comments_dict},()=>countDownNotification(notification.success,'Completado','El mensaje se eliminó de forma exitosa','success'))
      } 
      }).catch((err) => {
        notification.error({
          message:'Error',
          description:"Hubo un error. Intente mas tarde por favor",
        });
    })
  }
  editComment(comment){
    this.setState({edit_comment:true,selected_comment:comment.id, comment_new_text:comment.texto})
  }
  cancelComment(){
    this.setState({edit_comment:false,selected_comment:undefined,answer_comment:false, comment_new_text:''})
  }
  answerComment(commentId){
    this.setState({selected_comment:commentId,answer_comment:true,edit_comment:false})
  }
  
  getChildComments(comment){
    const { TextArea } = Input;
    return (this.state.edit_comment && this.state.selected_comment == comment.id &&
      <Comment
      actions={[<span onClick={()=>this.saveEditComment(comment.obra,comment.id)} >Guardar</span>, <span onClick={()=>this.cancelComment()} >Cancelar</span>]}
          avatar={
            <Avatar
          src={`https://ui-avatars.com/api/name=${this.state.jurys_dict[comment.jurado].nombre_completo}&background=random`}
          alt={this.state.jurys_dict[comment.jurado].nombre_completo}
        />
          }
          content={
            <TextArea value={this.state.comment_new_text} onChange={(val)=>{this.setState({comment_new_text:val.target.value})}}/>
          }
        >
                {comment.respuestas.map(id => {
          return this.getChildComments(this.state.comment[id])
      })}
      </Comment>
          
      || (this.state.answer_comment && this.state.selected_comment == comment.id &&
        <Comment
      actions={comment.jurado==this.state.current_jury.id ? [<span onClick={()=>this.editComment(comment)}>Editar</span>,<span onClick={()=>this.deleteComment(comment.obra, comment.id)} >Eliminar</span>,<span onClick={()=>this.answerComment(comment.id)} >Responder</span>]: [<span onClick={()=>this.answerComment(comment.id)}>Responder</span>]}
      author={<a>{this.state.jurys_dict[comment.jurado].nombre_completo}</a>}
      avatar={
        <Avatar
          src={`https://ui-avatars.com/api/name=${this.state.jurys_dict[comment.jurado].nombre_completo}&background=random`}
          alt={this.state.jurys_dict[comment.jurado].nombre_completo}
        />
      }
      content={
        <p>
          {comment.texto}
        </p>
      }
      datetime={
          <span>{moment(comment.fecha).format('YYYY-MM-DD HH:mm:ss')}</span>
      }
>       <Comment
        actions={[<Button type="primary" onClick={()=>this.postComment(this.state.currentRecordId,comment.id)} >Comentar</Button>, <Button type="text" onClick={()=>this.cancelComment()} >Cancelar</Button>]}
            avatar={
              <Avatar
            src={`https://ui-avatars.com/api/name=${this.state.current_jury.nombre_completo}&background=random`}
            alt={this.state.current_jury.nombre_completo}
          />
            }
            content={
              <TextArea placeholder="Escriba " value={this.state.comment_new_text} onChange={(val)=>{this.setState({comment_new_text:val.target.value})}}/>
            }
          > 
        </Comment>
        {comment.respuestas.map(id => {
          return this.getChildComments(this.state.comment[id])
        })}
      </Comment>
      ) ||
      <Comment
      actions={comment.jurado==this.state.current_jury.id ? [<span onClick={()=>this.editComment(comment)} key="comment-basic-edit-to">Editar</span>,<span  onClick={()=>this.deleteComment(comment.obra, comment.id)}  key="comment-basic-delete-to">Eliminar</span>,<span onClick={()=>this.answerComment(comment.id)}  key="comment-basic-reply-to">Responder</span>]: [<span onClick={()=>this.answerComment(comment.id)}  key="comment-basic-reply-to">Responder</span>]}
      author={<a>{this.state.jurys_dict[comment.jurado].nombre_completo}</a>}
      avatar={
        <Avatar
          src={`https://ui-avatars.com/api/name=${this.state.jurys_dict[comment.jurado].nombre_completo}&background=random`}
          alt={this.state.jurys_dict[comment.jurado].nombre_completo}
        />
      }
      content={
        <p>
          {comment.texto}
        </p>
      }
      datetime={
          <span>{moment(comment.fecha).format('YYYY-MM-DD HH:mm:ss')}</span>
      }
    >
      {comment.respuestas.map(id => {
          return this.getChildComments(this.state.comment[id])
      })}
      </Comment>
      )
  }
  getColumnSearchProps = (dataIndex,nombre) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <AutoComplete 
            style={{ width: 188, marginBottom: 8, display: 'block' }}
            options={this.getAutocomplete(dataIndex)}
            filterOption={(inputValue,option)=>option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
            onChange={(value)=>{setSelectedKeys(value ? [value] : [])}}
            value={selectedKeys[0]}

            >
              <Input
                ref={node => {
                  this.searchInput = node;
                }}
                placeholder={`Buscar ${nombre}`}
                onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
              />
            </AutoComplete>
            <Space>
              <Button
                type="primary"
                onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
              >
                Buscar
              </Button>
              <Button onClick={() =>{setSelectedKeys([]); this.handleReset(clearFilters)}} size="small" style={{ width: 90 }}>
                Resetear
              </Button>
    
            </Space>

          </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
          dataIndex!="author"?
           (record[dataIndex]
            ? record[dataIndex].toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())
            : ''):
            (record[dataIndex]? record[dataIndex].some(auth=>auth['name'].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())):'')
       ,
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => this.searchInput.select(), 100);
          }
        },
        render: (text,record,index) =>
           this.state.searchedColumn === dataIndex ? (
             dataIndex !="author"?
            (<div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
            </div>):
            record[dataIndex].map(auth=>
            (<div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={auth['name'] ? auth['name'] : ''}
            />
            </div>))
          ) : (
            <div style={{fontSize:'large', backgroundColor: this.state.current_jury.obras.includes(record.id) ? '#d9d9d9': 'white' }}>
              {(dataIndex=='edit' && <a onClick={()=>{this.onClickEditPlay(record)}}> <EditOutlined /></a>)||(dataIndex=="author" && <ol>{record.author.map((a,idx)=>{return <li><a onClick = {()=>this.onClickArticle(record)} >{a.name}</a> </li>})}</ol> )
              || (text)  }
            </div>
          ),
      });
    
      handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
          searchText: selectedKeys[0],
          searchedColumn: dataIndex,
        });
      };
      async openComments(record){
        var comments_dict = await getComments(record ? record:this.state.record.id)
        this.setState({showCommentSection:true, currentRecordId:record ? record:this.state.record.id, comment:comments_dict})
      }
      handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });

      };
   
  render() {
  
    const { Content } = Layout;
    const Moment = require('moment');
    const { TextArea } = Input;

    const columns = [
      {
        title: <div style={{fontWeight:'bold', fontSize:'large'}}>Número</div>,
        dataIndex: 'code',
        key: 'code',
        width:150,
        ...this.getColumnSearchProps('code','número'),
        responsive: ['sm'] 
      },
      {
        title: <div style={{fontWeight:'bold', fontSize:'large'}}>Título</div>,
        dataIndex: 'title',
        key: 'title',
        ...this.getColumnSearchProps('title','título'),
        responsive: ['sm'] 
      },
      {
        title: <div style={{fontWeight:'bold', fontSize:'large'}}>Seudónimo</div>,
        dataIndex: 'pseudo',
        key: 'pseudo',
        ...this.getColumnSearchProps('pseudo','seudónimo'),
        responsive: ['sm'] 
      }, 
      {
        dataIndex:"pdf",
        key:"pdf",
        align:'center',
        width:95, 
        render: (text,record)=> {
          return {
            props: {
              style: { background: "white",fontSize:'large' }
            },
            children:  
            
            <Button onClick={()=>readFile(text)}><FilePdfOutlined/> Leer</Button>
          }} 
      },
      {
        dataIndex:"id",
        key:"id",
        align:'center',
        width:130 ,
        render: (text,record)=> {
          return {
            props: {
              style: { background: "white",fontSize:'large',}
            },
            children:  
            <Button onClick={() => downloadFile(record)} ><FilePdfOutlined/>  Descargar</Button>
          }}
        },
      {
        dataIndex:"id",
        key:"id",
        align:'center',
        render: (text,record)=> {
          return {
            props: {
              style: { background:  "white",fontSize:'large',width:173 }
            },
            children: <div> <Button onClick={() => this.openComments(record.id)} ><FileTextOutlined />  Comentarios</Button></div>
          }
        } 
      }];
    for(var j in this.state.jurys_dict){
        var column = {
          title: <div style={{fontWeight:'bold', fontSize:'large', position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignElements:'center',}}>{this.state.jurys_dict[j].usuario}</div>,
          dataIndex: j.toString(),
          key: j.toString(),
          width:"100px",
          render: (text,record,index) =>
            (
            <div style={{fontSize:'large', backgroundColor: 'white', position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignElements:'center' }}>
                {text}
            </div>
          ),
          responsive: ['sm'] }
      columns.push(column)
    }
  
    const closeComments=()=>{
      this.setState({showCommentSection:false,editComment:false, selected_comment:undefined})
    }
    return (
      <div className="page-container">
        <div className = "content-wrap">
          <ConfigProvider locale={es_ES}>
            <Layout style={{backgroundColor:'white'}}>
              <JuryMenu defaultSelectedKey={"plays_final"} name ={this.state.current_jury?.nombre_completo}/>
              <Content>
                <Card>
                  <Row justify="center" align="middle">
                    <Col span={16}>
                      <Table
                        loading={!this.state.loaded_table_data}
                        columns={columns}
                        dataSource= {this.state.plays}
                        pagination={{ position: ["bottomCenter"],}} 
                        tableLayout='fixed'
                        size='small'
                        style={{ whiteSpace: 'normal'}}
                        onChange = {this.handleTableChange}
                      />
                    </Col>
                  </Row>
                </Card>
              {this.state.showArticle && 
                <Modal 
                    closable = {false}
                    title={ this.state.record.code}
                    visible={this.state.showArticle} 
                    onCancel={this.hideModal}
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                        Regresar
                        </Button>,
                    ]}
                  >
                    <p><FileTextOutlined />Título: {this.state.record.title}</p>
                    <p><QrcodeOutlined />Código: {this.state.record.code}  </p>
                    <p><CalendarOutlined />Fecha: {this.state.record.date}   </p>
                    <p><TagsOutlined />Género: 
                      {this.state.record.category} 
                    </p>
                    <p><AuditOutlined />Seudónimo: {this.state.record.pseudo} </p>
                    <p>
                      <Button onClick={readFile}><FilePdfOutlined/> Leer PDF</Button>
                      <Button onClick={downloadFile} >
                      <FilePdfOutlined/>  Descargar PDF
                        </Button>
                      <Button onClick={() => this.openComments()} ><FileTextOutlined />  Comentarios</Button>
                    </p>
                </Modal>
              }
              { this.state.showCommentSection && 
                <Modal 
                  closable = {false}
                  title={ "Comentarios"}
                  visible={this.state.showCommentSection} 
                  width={580}
                  footer={[
                      <Button key="back" onClick={closeComments}>
                      Cerrar
                      </Button>,
                  ]}
                >
                  <Row align="middle" justify="center" >
                    <Col span={24}>
                      <Comment
                        actions={[<Button type="primary" onClick={()=>this.postComment(this.state.currentRecordId)} >Comentar</Button>, <Button type="text" onClick={()=>this.cancelComment()} >Cancelar</Button>]}
                        avatar={
                          <Avatar
                            src={`https://ui-avatars.com/api/name=${this.state.jurys_dict[this.state.current_jury.id].nombre_completo}&background=random`}
                            alt={this.state.jurys_dict[this.state.current_jury.id].nombre_completo}
                          />
                        }
                        content={
                          <TextArea placeholder={"Añadir comentario"} value={this.state.comment_new_text} onChange={(val)=>{this.setState({comment_new_text:val.target.value})}}/>
                        }
                      />
                      {
                        Object.entries(this.state.comment).map(element=>{
                          if (!element[1].comentario_padre){
                            return this.getChildComments(element[1])
                          }
                        })
                      }
                    </Col>
                  </Row>
                </Modal>}
                {this.state.openEditFinalComment && 
                  <Modal
                    closable = {false}
                    title={ "Comentario sobre selección de obra (opcional)"}
                    visible={this.state.openEditFinalComment} 
                    onCancel={()=>this.setState({openEditFinalComment:false})}
                    footer={[
                        <Button key="back" onClick={()=>this.setState({openEditFinalComment:false})}>
                        Regresar
                        </Button>,
                    ]}
                  >
                    <Comment
                        actions={[<Button type="primary"  onClick={ ()=>this.setState({openEditFinalComment:false},()=>this.postFinalComment())} >Guardar</Button>, <Button type="text" onClick={()=>this.setState({openEditFinalComment:false, comment_new_text:''})} >Cancelar</Button>]}
                        avatar={
                            <Avatar
                              src={`https://ui-avatars.com/api/name=${this.state.jurys_dict[this.state.current_jury.id].nombre_completo}&background=random`}
                              alt={this.state.jurys_dict[this.state.current_jury.id].nombre_completo}
                            />
                        }
                        content={
                          <TextArea placeholder={"Añadir comentario"} defaultValue={this.state.finalCommentText} value={this.state.comment_new_text} onChange={(val)=>{console.log(val.target.value);this.setState({comment_new_text:val.target.value});}}/>
                        }
                      />
                  </Modal>}
              </Content>
          </Layout>
        </ConfigProvider>
    </div>
    <Foot jury={true}/>
    </div>
    );
  }
}
export default FinalPlayslist;